import React from 'react';
import { connect } from 'react-redux';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { CATEGORY_TRANSFER_FROM_ACH } from 'apps/auth/constants/Constants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const CancelOperationPopup = (props) => {
    const { cancelTransferTitle, cancelAchTransferTitle, cancelTransferContinue, cancelTransferCancel, cancelAchTransferCancel } = usePageMessages();

    const getText = (providerFromCategory) => {
        if (providerFromCategory === CATEGORY_TRANSFER_FROM_ACH) {
            return cancelAchTransferTitle;
        } else {
            const titleArr = cancelTransferTitle?.split('\\n');
            return titleArr.map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            ));
        }
    };

    return (
        <SimplePopup popupRef={props.popupRef} text={getText(props.cheque.providerFromCategory)}>
            <PopupButton
                iconName="arrow-back-circular"
                text={cancelTransferContinue}
                onClick={(e) => {
                    e.preventDefault();
                    props.popupRef?.current?.close();
                }}
            />
            <PopupButton
                iconName="cross"
                text={props.cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_ACH ? cancelAchTransferCancel : cancelTransferCancel}
                onClick={(e) => {
                    e.preventDefault();
                    props.cancelAction();
                }}
            />
        </SimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        cheque: state.history.cheque.cheque,
    };
};
export default connect(mapStateToProps)(CancelOperationPopup);
